import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface GlobalSearchResponseDto {
  people: GlobalSearchPersonResultDto[];
  units: GlobalSearchUnitResultDto[];
}

export interface GlobalSearchPersonResultDto {
  id: string;
  fullName: string;
  documentNumber?: string | null;
  membershipUnitId: string;
  membershipUnitName: string;
  ministryName?: string | null;
  ministrySortOrder?: number | null;
}

export interface GlobalSearchUnitResultDto {
  id: string;
  name: string;
  levelName: string;
  organizationLevelId: number;
  parentName?: string | null;
}

@Injectable({ providedIn: 'root' })
export class SearchApiService {
  private readonly apiUrl = `${environment.apiUrl}/search`;

  constructor(private readonly http: HttpClient) {}

  search(term: string, types: Array<'people' | 'units' | 'active-ministry-bearers' | 'spiritual-assistance-eligible-visitors'> = ['people', 'units'], limitPerType = 6, includeInitialResults = false, eligibilityDate?: string): Observable<GlobalSearchResponseDto> {
    let params = new HttpParams()
      .set('term', term)
      .set('limitPerType', limitPerType)
      .set('includeInitialResults', includeInitialResults);

    for (const type of types) {
      params = params.append('types', type);
    }

    if (eligibilityDate) params = params.set('eligibilityDate', eligibilityDate);

    return this.http.get<GlobalSearchResponseDto>(this.apiUrl, { params });
  }
}
